import { render, staticRenderFns } from "./SettingsPaymentCheck.vue?vue&type=template&id=3e1df8d4&lang=pug&"
import script from "./SettingsPaymentCheck.vue?vue&type=script&lang=js&"
export * from "./SettingsPaymentCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e1df8d4')) {
      api.createRecord('3e1df8d4', component.options)
    } else {
      api.reload('3e1df8d4', component.options)
    }
    module.hot.accept("./SettingsPaymentCheck.vue?vue&type=template&id=3e1df8d4&lang=pug&", function () {
      api.rerender('3e1df8d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayment/SettingsPaymentCheck.vue"
export default component.exports